import React, { Component } from "react";
import './download-page.less'
import { phonePlatform } from '../../util/util';
import { setHeader } from "@/util/set-header";
import { Button } from "antd-mobile";

export default class DownloadPage extends Component<any, any> {

    UNSAFE_componentWillMount() {
        setHeader({ className: "no-navbar" })
    }

    componentDidMount() {
        this.download()
    }

    download = () => {
        const platform = phonePlatform()
        if (platform === 'iOS') {//iOS下载地址
            window.location.href = 'itms-services://?action=download-manifest&url=https://sanyiyungusushe-1252579942.cos.ap-beijing.myqcloud.com/cdn/app-pic/manifest.plist'
        } else if (platform === 'Android') {//Android下载地址
            window.location.href = 'https://sanyiyungusushe-1252579942.cos.ap-beijing.myqcloud.com/app_package/app-release.apk'
        }
    }

    render() {
        return (
            <div className="download-page">
                <img src='/public/assets/img/sanyi_logo.png' alt="logo" />
                <Button type="primary" className="download-btn" onClick={this.download}>下载</Button>
                <span className='download-tips'>1、如没有自动下载,请点击下载按钮.<br />2、微信扫码用户,请点击右上角按钮-"浏览器"中打开.</span>
            </div>
        )
    }
}